<template>
    <div class="row">
        <div class="section">
            <div class="col s12 m2 l2">
                <ul class="collection">
                    <li class="collection-item nav-suite-nupcias"><a class="white-text" href="#/acomodacoes/suite-nupcias">Suíte de Núpcias</a></li>
                    <li class="collection-item nav-quarto-casal"><a class="white-text" href="#/acomodacoes/quarto-casal">Quarto Casal</a></li>
                    <li class="collection-item nav-quarto-duplo"><a class="white-text" href="#/acomodacoes/quarto-duplo">Quarto Duplo</a></li>
                    <li class="collection-item nav-quarto-individual"><a class="white-text" href="#/acomodacoes/quarto-individual">Quarto Individual</a></li>
                </ul>
            </div>
            <div class="col s12 m10 l10">
                <div class="container">
                    <div class="slider">
                        <ul class="slides">
                            <!-- SIGLE -->
                            <li>
                                <img src="../../img/galeriaFotos/092.jpg"> <!-- random image -->
                                <div class="caption left-align">
                                    <h3>Quarto Individual</h3>
                                </div>
                            </li>
                            <li>
                                <img src="../../img/galeriaFotos/090.jpg"> <!-- random image -->
                                <div class="caption right-align">
                                    <h3>Toaletes</h3>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col s12 m12 l12">
                            <div class="card z-depth-2 hoverable">
                                <div class="card-content">
                                    <span class="card-title">Acomodações</span>
                                    <p>Nossos apartamentos e suítes são todos de luxo e oferecem
                                        excelente estrutura e conforto equipados com <b>frigobar, ar condicionado,
                                            ventilador, TV e armário com cabides.</b>
                                    </p>
                                    <p>Explore os diferentes tipos de apartamentos!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

    export default {
        mounted(){
            $('nav div ul').children().removeClass('active');
            $('.nav-acom').addClass('active');
            $('.nav-quarto-individual').addClass('active');

            $('.slider').slider();
            $('.materialboxed').materialbox();
        }
    };
</script>


// WEBPACK FOOTER //
// quarto-individual.vue?c8363882